import Loader from 'components/Loader'
import React, { Suspense } from 'react'
import { Route, Switch } from 'react-router'
import CuponesAutoservicio from './CuponesAutoservicio/CuponesAutoservicio'
import ConfiguracionInicial from './ConfiguracionInicial/ConfiguracionInicial'

const Autoservicio = ({ match }: any) => {
     return (
          <div className='app-wrapper'>
               <Switch>
                    <Suspense fallback={<Loader />}>
                         <Route path={`${match.url}/cupones`} component={CuponesAutoservicio} />
                         <Route path={`${match.url}/configuracion-inicial`} component={ConfiguracionInicial} />
                    </Suspense>
               </Switch>
          </div>
     )
}

export default Autoservicio